import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useDiscountsReportV2 = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.discountsReportV2, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getDiscountsReportV2(), {
        params,
      });

      const composeResponse = {
        clinics: Object.values(res.data.data.filters.clinics || {}),
        clinicDiscounts: res.data.data.report.clinic_report,
        providerDiscounts: res.data.data.report.provider_report,
      };
      return composeResponse;
    },
    options,
  );
};
